module.exports = __webpack_public_path__ + "frontend/images/benefits/free.gif?1fbb30f79af913beaed270e3e9eff14b";